var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 121",
    className: "w-[120px] h-[120px] shrink-0",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#syncRealTime_svg__a)",
    d: "M63.66 13.218c22.251 7.935 37.792 62.865 26.67 79.987-11.122 17.122-70.502-.364-80.767-14.935C-.702 63.7 41.409 5.28 63.659 13.218Z",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#syncRealTime_svg__b)",
    d: "M39.072 23.236C59.619 18.349 98.02 51.962 98.02 70.214c0 18.253-53.033 34.061-67.825 28.137-14.791-5.924-11.67-70.227 8.877-75.115Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M69.182 70.606h-7.55a1.667 1.667 0 0 0 0 3.333h4a13.334 13.334 0 0 1-22.967-9.183 1.667 1.667 0 0 0-3.333 0 16.667 16.667 0 0 0 28.133 12.05v2.95a1.667 1.667 0 1 0 3.334 0v-7.5a1.667 1.667 0 0 0-1.617-1.65ZM55.999 48.089a16.666 16.666 0 0 0-11.467 4.617v-2.95a1.667 1.667 0 0 0-3.333 0v7.5a1.666 1.666 0 0 0 1.666 1.667h7.5a1.667 1.667 0 0 0 0-3.334h-4a13.333 13.333 0 0 1 22.967 9.167 1.666 1.666 0 1 0 3.333 0A16.666 16.666 0 0 0 56 48.089Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "syncRealTime_svg__a",
    x1: 83.124,
    x2: 36.29,
    y1: 25.221,
    y2: 97.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#33C8C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#119BD2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "syncRealTime_svg__b",
    x1: 59.51,
    x2: 59.51,
    y1: 99.616,
    y2: -7.988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#348F50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56B4D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncIcon);
export default __webpack_public_path__ + "static/media/sync-icon.a92f440d6f70e79544185b774e81b4f7.svg";
export { ForwardRef as ReactComponent };